import { render, staticRenderFns } from "./blackSetting.vue?vue&type=template&id=9cc287b6&scoped=true&"
import script from "./blackSetting.vue?vue&type=script&lang=js&"
export * from "./blackSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc287b6",
  null
  
)

export default component.exports